enum PlanzoneRole {
  ADMINISTRATOR = "101",
  SUB_ADMINISTRATOR = "102",
  WORKER = "103",
}

export { PlanzoneRole };
